import {JSONModel, jsonProperty} from "../json.model";
import {toList} from "../helpers/helpers";

export class SmartsheetWorkspaceModel extends JSONModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") name: string;

  static fromList(obj: any): SmartsheetWorkspaceModel[] {
    return toList(it => new SmartsheetWorkspaceModel(it), obj);
  }
}
